<form #webHookForm="ngForm" class="small-labels" id="{{idString}}">
    <div class="row" *ngIf="webhookDefData">
        <div class="mb-3" [ngClass]="columClass" *ngIf="webHookFormElemCustomFields?.workflow_name?.visible">
            <label for="{{idString}}-webhook_name" class="form-label">Webhook Name</label>
            <input type="text" class="form-control form-control-sm" name="webhook_name" id="{{idString}}-webhook_name"
                [required]="webHookFormElemCustomFields?.workflow_name?.mandatory"
                [(ngModel)]="webhookDefData.workflow_name" #webhook_name="ngModel"
                [disabled]="webHookFormElemCustomFields?.workflow_name?.readOnly">
            <div *ngIf="webhook_name.invalid && (webhook_name.dirty || webhook_name.touched)" class="invalid-feedback">
                <div *ngIf="webhook_name.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
            </div>
        </div>
        <div class="mb-3" [ngClass]="columClass" *ngIf="webHookFormElemCustomFields?.webhook_url?.visible">
            <label for="{{idString}}-webhook_url" class="form-label">Webhook URL</label>
            <input type="text" class="form-control form-control-sm" name="webhook_url" id="{{idString}}-webhook_url"
                [required]="webHookFormElemCustomFields?.webhook_url?.mandatory"
                [(ngModel)]="webhookDefData.webhook_url" #webhook_url="ngModel"
                [pattern]="regExPatterns.urlRegexWithPort"
                [disabled]="webHookFormElemCustomFields?.webhook_url?.readOnly">
            <div *ngIf="webhook_url.invalid && (webhook_url.dirty || webhook_url.touched)" class="invalid-feedback">
                <div *ngIf="webhook_url.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="webhook_url.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>
        <div class="mb-3" [ngClass]="columClass" *ngIf="webHookFormElemCustomFields?.vendor_api_endpoint?.visible">
            <label for="{{idString}}-vendor_api_endpoint" class="form-label">Vendor API Endpoint</label>
            <input type="text" class="form-control form-control-sm" name="vendor_api_endpoint"
                id="{{idString}}-vendor_api_endpoint"
                [required]="webHookFormElemCustomFields?.vendor_api_endpoint?.mandatory"
                [(ngModel)]="webhookDefData.vendor_api_endpoint" #vendor_api_endpoint="ngModel"
                [pattern]="regExPatterns.urlRegexWithPortCapitalLettersAllowed"
                [disabled]="webHookFormElemCustomFields?.vendor_api_endpoint?.readOnly">
            <div *ngIf="vendor_api_endpoint.invalid && (vendor_api_endpoint.dirty || vendor_api_endpoint.touched)"
                class="invalid-feedback">
                <div *ngIf="vendor_api_endpoint.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="vendor_api_endpoint.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>
        <div class="mb-3" [ngClass]="columClass" *ngIf="webHookFormElemCustomFields?.partner_api_endpoint?.visible">
            <label for="{{idString}}-partner_api_endpoint" class="form-label">Partner API Endpoint</label>
            <input type="text" class="form-control form-control-sm" name="partner_api_endpoint"
                id="{{idString}}-partner_api_endpoint"
                [required]="webHookFormElemCustomFields?.partner_api_endpoint?.mandatory"
                [(ngModel)]="webhookDefData.partner_api_endpoint" #partner_api_endpoint="ngModel"
                [pattern]="regExPatterns.urlRegexWithPort"
                [disabled]="webHookFormElemCustomFields?.partner_api_endpoint?.readOnly">
            <div *ngIf="partner_api_endpoint.invalid && (partner_api_endpoint.dirty || partner_api_endpoint.touched)"
                class="invalid-feedback">
                <div *ngIf="partner_api_endpoint.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="partner_api_endpoint.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>
        <div class="mb-3" [ngClass]="columClass" *ngIf="webHookFormElemCustomFields?.vendor_api_secret?.visible">
            <label for="{{idString}}-vendor_api_secret" class="form-label">Vendor Secret Key</label>
            <input type="text" class="form-control form-control-sm" name="vendor_api_secret"
                id="{{idString}}-vendor_api_secret"
                [required]="webHookFormElemCustomFields?.vendor_api_secret?.mandatory"
                [(ngModel)]="webhookDefData.vendor_api_secret" #vendor_api_secret="ngModel"
                [disabled]="webHookFormElemCustomFields?.vendor_api_secret?.readOnly">
            <div *ngIf="vendor_api_secret.invalid && (vendor_api_secret.dirty || vendor_api_secret.touched)"
                class="invalid-feedback">
                <div *ngIf="vendor_api_secret.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="vendor_api_secret.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>
        <div class="mb-3" [ngClass]="columClass" *ngIf="webHookFormElemCustomFields?.partner_api_secret?.visible">
            <label for="{{idString}}-partner_api_secret" class="form-label">CSP Secret Key</label>
            <input type="text" class="form-control form-control-sm" name="partner_api_secret"
                id="{{idString}}-partner_api_secret" [required]="webHookFormElemCustomFields?.partner_api_secret?.mandatory"
                [(ngModel)]="webhookDefData.partner_api_secret" #partner_api_secret="ngModel"
                [disabled]="webHookFormElemCustomFields?.partner_api_secret?.readOnly">
            <div *ngIf="partner_api_secret.invalid && (partner_api_secret.dirty || partner_api_secret.touched)"
                class="invalid-feedback">
                <div *ngIf="partner_api_secret.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="partner_api_secret.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>
        <div class="mb-3" *ngIf="webHookFormElemCustomFields?.custom_fields?.visible">
            <label for="{{idString}}-custom_fields" class="form-label">Custom Fields (Paste JSON here)</label>
            <textarea id="{{idString}}-custom_fields" class="form-control form-control-sm wh-json-textarea"
                name="custom_fields" (input)="onCustomFieldsKeyUp($event)" [(ngModel)]="webhookDefData.custom_fields"
                #custom_fields="ngModel" [disabled]="webHookFormElemCustomFields?.custom_fields?.readOnly"></textarea>
            <div *ngIf="customeFieldsError || (custom_fields.invalid && (custom_fields.dirty || custom_fields.touched))"
                class="invalid-feedback">
                <div *ngIf="!customeFieldsError && custom_fields.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="customeFieldsError">
                    {{errorMsgs.enterValidJosn}}
                </div>
            </div>
        </div>
    </div>
</form>